import * as React from "react";
import Screen from "../../components/screen/Screen";
import {ROUTE_HOME} from "../../routing/Routes";
import {FormattedMessage} from 'react-intl';


interface Props {

}

export default class ClubScreen extends React.Component<Props> {


    public render(): React.ReactNode {

        return (
            <Screen currentRoute={ROUTE_HOME}>
                <div className={"section-container"}>
                    <h2><FormattedMessage id={"club.title"}/></h2>

                    <div className={"content"}>
                        <FormattedMessage id={"club.description"}/>
                    </div>
                </div>
            </Screen>
        )
    }
}